import { resolveVariablesInText } from '../../../../lib/template-variables';
import type { VariableContext } from '../../../../lib/template-variables/registry';
import type { DocumentationSettings } from '../types';

/** Map legacy supervisor macro tokens to the variable registry syntax. */
export function migrateFooterMacros(text: string): string {
  return text
    .replace(/\{\{Supervisor\}\}/g, '{{supervisor.name}}')
    .replace(/\{\{SupervisorFullName\}\}/g, '{{supervisor.fullName}}')
    .replace(/\{\{SupervisorLicenseNumber\}\}/g, '{{supervisor.licenseNumber}}')
    .replace(/\{\{SupervisorNPINumber\}\}/g, '{{supervisor.npiNumber}}');
}

export function shouldUsePreLicensedDocumentFormat(
  settings: DocumentationSettings,
  requiresCosignature: boolean,
): boolean {
  return requiresCosignature && settings.documentFormat.preLicensedFormat.addSupervisorInfo;
}

export function getRawDocumentFooterText(
  settings: DocumentationSettings,
  usePreLicensedFormat: boolean,
): string {
  const footer = usePreLicensedFormat
    ? settings.documentFormat.preLicensedFormat.footerText
    : settings.documentFormat.standardFormat.footerText;
  return migrateFooterMacros(footer);
}

export function resolveDocumentFooterText(
  settings: DocumentationSettings,
  context: VariableContext,
  options: {
    usePreLicensedFormat: boolean;
    onUnresolved?: 'token' | 'placeholder';
  },
): string | undefined {
  const raw = getRawDocumentFooterText(settings, options.usePreLicensedFormat).trim();
  if (!raw) return undefined;
  const resolved = resolveVariablesInText(raw, context, {
    onUnresolved: options.onUnresolved ?? 'placeholder',
    placeholder: '',
  }).trim();
  return resolved || undefined;
}

export function shouldShowPracticeLogo(settings: DocumentationSettings): boolean {
  return settings.documentFormat.standardFormat.includePracticeLogo;
}
